import { 
  HiHome, 
  HiDocumentText, 
  HiHeart, 
  HiUsers, 
  HiBriefcase, 
  HiAcademicCap, 
  HiLockClosed, 
  HiClipboardDocumentCheck, 
  HiPhone,
  HiMagnifyingGlass,
  HiArrowPathRoundedSquare,
  HiFlag
} from 'react-icons/hi2';

export const navigationItems = [
  {
    id: 'home',
    path: '/home',
    icon: HiHome,
    labelKey: 'nav.home'
  },
  {
    id: 'entry-residence',
    path: '/entree-sejour',
    icon: HiDocumentText,
    labelKey: 'nav.entryResidence'
  },
  {
    id: 'health',
    path: '/sante',
    icon: HiHeart,
    labelKey: 'nav.health'
  },
  {
    id: 'civil-family',
    path: '/etat-civil-famille',
    icon: HiUsers,
    labelKey: 'nav.civilFamily'
  },
  {
    id: 'work-housing',
    path: '/travail-logement',
    icon: HiBriefcase,
    labelKey: 'nav.workHousing'
  },
  {
    id: 'education-justice',
    path: '/education-justice',
    icon: HiAcademicCap,
    labelKey: 'nav.educationJustice'
  },
  {
    id: 'detention',
    path: '/detention',
    icon: HiLockClosed,
    labelKey: 'nav.detention'
  },
  {
    id: 'documents',
    path: '/documents',
    icon: HiClipboardDocumentCheck,
    labelKey: 'nav.documents'
  },
  {
    id: 'contact',
    path: '/contact',
    icon: HiPhone,
    labelKey: 'nav.contact'
  },
  {
    id: 'consulates',
    path: '/consulates',
    icon: HiFlag,
    labelKey: 'nav.consulates'
  },
  {
    id: 'wizards',
    path: '/wizards',
    icon: HiArrowPathRoundedSquare,
    labelKey: 'wizards.title'
  },
  {
    id: 'search',
    path: '/search',
    icon: HiMagnifyingGlass,
    labelKey: 'search.title'
  }
];
